import React from 'react';
import { Button } from './ui/Button';
import { BOOKING_URL } from '../lib/navigation';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gradient-to-b from-neutral-soft to-white" data-id="element-81">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 pointer-events-none" data-id="element-82">
        <svg viewBox="0 0 100 100" className="w-full h-full text-sage fill-current" data-id="element-83">
          <path d="M0 0 C 50 0 50 100 100 100 L 100 0 Z" data-id="element-84" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-85">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center" data-id="element-86">
          <div className="lg:col-span-3 space-y-8 animate-fade-in-up" data-id="element-87">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display italic font-medium text-teal leading-tight text-balance" data-id="element-88">
              Where acceptance meets change
            </h1>

            <p className="text-xl md:text-2xl text-teal/80 font-light leading-relaxed text-balance" data-id="element-89">
              Therapy for adults navigating anxiety, comparison, and the
              pressure to have it all figured out.
            </p>

            <p className="text-lg text-teal/70 leading-relaxed max-w-lg" data-id="element-90">
              You don't have to perform your life for an invisible audience.
              Let's build something that feels like yours.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-91">
              <Button size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-92">
                Book a Free Consultation
              </Button>
            </div>

            <div className="pt-8 border-t border-sage/20" data-id="element-93">
              <p className="text-sm font-medium text-teal/60 uppercase tracking-wider" data-id="element-94">
                Online therapy across Ontario · Registered Psychotherapist
                (Qualifying)
              </p>
            </div>
          </div>

          <div className="hidden lg:block lg:col-span-2 relative h-[500px] w-full" data-id="element-95">
            <svg className="w-full h-full" viewBox="0 0 400 500" xmlns="http://www.w3.org/2000/svg" data-id="element-96">
              <path d="M 40,450 C 120,450 120,360 200,360 C 280,360 280,270 200,200 C 120,130 280,40 360,40" stroke="#7da8a0" strokeWidth="2" fill="none" className="animate-draw-path" strokeDasharray="2000" strokeDashoffset="2000" data-id="element-97" />
              <circle cx="360" cy="40" r="8" fill="#d4a574" className="animate-fade-in-up" style={{
              animationDelay: '1.5s'
            }} data-id="element-98" />
              <circle cx="80" cy="80" r="120" fill="#7da8a0" fillOpacity="0.05" data-id="element-99" />
              <circle cx="320" cy="340" r="80" fill="#d4a574" fillOpacity="0.05" data-id="element-100" />
            </svg>
          </div>
        </div>
      </div>
    </section>;
}